import { render, staticRenderFns } from "./OrderTableChildAction.vue?vue&type=template&id=4681d58e"
import script from "./OrderTableChildAction.vue?vue&type=script&lang=js"
export * from "./OrderTableChildAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports